import { modal } from "../modal";

function appendModalContent(content) {
  modal.append(content);
}

export { appendModalContent };
